module.exports = __webpack_public_path__ + "6139dd99f80cf5fbc1b919b765355d44.fbx";